import React from 'react';
import { Outlet } from 'react-router-dom';

import { ApplicationDialog } from '@/components/organisms/ApplicationDialog';
import { useFlowContext } from '@/hooks/useFlowContext';

interface Props {
  readonly parentPath: string;
}

export const ModalFlow: React.FC<Props> = (props: Props): React.ReactElement => {
  const { parentPath } = props;

  const context = useFlowContext(parentPath);

  return (
    <ApplicationDialog>
      <Outlet context={context} />
    </ApplicationDialog>
  );
};
